
document.addEventListener("DOMContentLoaded", function() {
  // Collect all <li> texts from the metafield list
  const liTexts = Array.from(
    document.querySelectorAll("div#ProductInformation-template--25993735602458__main ul.metafield-single_line_text_field-array li.metafield-single_line_text_field")
  ).map(el => el.textContent.trim().toLowerCase());

  // Loop through each product info block
  const blocks = document.querySelectorAll(
    "div#ProductInformation-template--25993735602458__main .group-block-content.layout-panel-flex.layout-panel-flex--row .group-block.group-block--height-fill.group-block--width-fill.border-style.spacing-style.size-style"
  );

  blocks.forEach(block => {
    // Find the <strong> inside this block
    const strong = block.querySelector(
      ".group-block-content.layout-panel-flex.layout-panel-flex--column.mobile-column .spacing-style.text-block h3 strong"
    );

    if (strong) {
      const strongText = strong.textContent.trim().toLowerCase();

      // If the <strong> text matches any <li> text, add .feature__item to the block
      if (liTexts.includes(strongText)) {
        block.classList.add("feature__item");
      }
    }
  });
});





(function () {
  const WORD_LIMIT = 40;
  const SELECTOR = "rte-formatter.text-block--ANTNicGtOZFV5eVpxd__text_kYpyJd";

  function truncateHTML(element, limit) {
    let wordCount = 0;

    function walk(node) {
      if (wordCount >= limit) {
        node.remove();
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.trim().split(/\s+/);

        if (wordCount + words.length > limit) {
          const remaining = limit - wordCount;
          node.textContent = words.slice(0, remaining).join(" ") + "...";
          wordCount = limit;
        } else {
          wordCount += words.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(child => walk(child));
      }
    }

    const clone = element.cloneNode(true);
    walk(clone);
    return clone.innerHTML;
  }

  function initOnRTE(rte) {
    if (!rte) return;

    const fullHTML = rte.innerHTML.trim();
    const textOnly = rte.innerText || rte.textContent || "";
    const words = textOnly.trim().split(/\s+/);
    const isLong = words.length > WORD_LIMIT;

    const wrapper = document.createElement("div");
    wrapper.className = "collection-description-wrapper";

    const content = document.createElement("div");
    content.className = "collection-description-content";

    rte.parentNode.insertBefore(wrapper, rte);
    wrapper.appendChild(content);

    rte.style.display = "none";

    if (isLong) {
      const truncatedHTML = truncateHTML(rte, WORD_LIMIT);
      content.innerHTML = truncatedHTML;

      const btn = document.createElement("button");
      btn.className = "collection-description-toggle";
      btn.type = "button";
      btn.innerText = "Read More";
      wrapper.appendChild(btn);

      btn.addEventListener("click", function () {
        const expanded = wrapper.classList.toggle("expanded");

        if (expanded) {
          content.innerHTML = fullHTML;
          btn.innerText = "Read Less";
        } else {
          content.innerHTML = truncatedHTML;
          btn.innerText = "Read More";
        }
      });

    } else {
      content.innerHTML = fullHTML;
    }
  }

  const run = () => {
    const rte = document.querySelector(SELECTOR);
    if (rte) initOnRTE(rte);
  };

  run();

  const obs = new MutationObserver(() => {
    const rte = document.querySelector(SELECTOR);
    if (rte && !document.querySelector(".collection-description-wrapper")) {
      initOnRTE(rte);
    }
  });

  obs.observe(document.documentElement || document.body, {
    childList: true,
    subtree: true,
  });
})();






document.addEventListener('click', (event) => {
  const btn = event.target.closest('.price-facet__apply');
  if (btn) {
    // 1. Show the loader
    btn.classList.add('is-loading');

    // 2. We need to hide it once AJAX is done. 
    // Since Shopify AJAX updates the HTML, the button is usually 
    // replaced by a new one from the server.
    // If your theme DOES NOT refresh the button, use this observer:
    const productContainer = document.querySelector('#ProductGridContainer') || document.body;
    
    const observer = new MutationObserver(() => {
      btn.classList.remove('is-loading');
      observer.disconnect();
    });

    observer.observe(productContainer, { childList: true, subtree: true });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector(".dialog-zoomed-gallery");
  const thumbnails = document.querySelector(".dialog-thumbnails-list");

  if (!gallery) return;

  let startX = 0;

  const slides = gallery.querySelectorAll(".product-media-container");
  const thumbs = thumbnails
    ? thumbnails.querySelectorAll(".dialog-thumbnails-list__thumbnail")
    : [];

  function setActive(index) {
    if (!slides[index]) return;

    slides[index].scrollIntoView({ behavior: "smooth" });

    if (thumbs.length) {
      thumbs.forEach((t) => t.removeAttribute("aria-selected"));

      if (thumbs[index]) {
        thumbs[index].setAttribute("aria-selected", "true");
        thumbs[index].scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  }

  function getActiveIndex() {
    let closest = 0;
    let min = Infinity;

    slides.forEach((slide, i) => {
      const rect = slide.getBoundingClientRect();
      const distance = Math.abs(rect.left);
      if (distance < min) {
        min = distance;
        closest = i;
      }
    });

    return closest;
  }

  gallery.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  gallery.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    const active = getActiveIndex();

    if (diff > 50 && slides[active + 1]) {
      setActive(active + 1);
    }

    if (diff < -50 && slides[active - 1]) {
      setActive(active - 1);
    }
  });
});